import React, { Suspense, useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SplashScreen } from './components/SplashScreen';
import { IconsLoader } from './components/IconsLoader';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/**
 * Root component that shows splash screen during initial app load
 * This provides visual feedback while the JavaScript bundle is downloading and parsing
 */
const Root: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Hide the initial HTML loading screen immediately when React mounts
    const initialLoadingScreen = document.getElementById('initial-loading-screen');
    if (initialLoadingScreen) {
      initialLoadingScreen.classList.add('hidden');
    }

    // Hide splash screen once React has mounted and initial render is complete
    // This gives time for the bundle to parse and initial components to render
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 100); // Small delay to ensure smooth transition

    return () => clearTimeout(timer);
  }, []);

  return (
    <React.StrictMode>
      {isLoading && <SplashScreen message="Loading Calculist..." />}
      <div style={{ opacity: isLoading ? 0 : 1, transition: 'opacity 0.3s ease-in' }}>
        <IconsLoader>
          <Suspense fallback={<SplashScreen message="Loading..." />}>
            <App />
          </Suspense>
        </IconsLoader>
      </div>
    </React.StrictMode>
  );
};

root.render(<Root />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
